<bmcore-common-slider [producers]="producers | slice: 0 : 6"></bmcore-common-slider>
